export default __webpack_public_path__ + "images/Crepes.d820f3.jpg";